import React, { useState } from 'react';
import './Hero.css';

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const images = [
    '/screenshots/Simulator Screenshot - iPhone 16 Pro - 2025-09-28 at 22.10.19.png',
    '/screenshots/simulator_screenshot_2958AD9A-83B5-44FB-999E-0E8A2160D8CD.png',
    '/screenshots/simulator_screenshot_A69FDE28-1434-4764-A0C8-F163F5E68973.png'
  ];

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-left">
          <div className="hero-slideshow">
            <button className="nav-arrow nav-arrow-left" onClick={prevImage}>‹</button>
            <img src={images[currentImage]} alt="Miyel app screenshots" className="hero-image" />
            <button className="nav-arrow nav-arrow-right" onClick={nextImage}>›</button>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-content">
            <p className="hero-tagline">Miyel</p>
            <h1 className="hero-title">hands on peace of <strong>mine</strong></h1>
            <p className="hero-subtitle">our most precious cargo deserves a helping hand</p>
            <p className="hero-description">A solution made for families to help prevent vehicular tragedies.</p>
          </div>
        </div>
      </div>
      <div className="hero-value-prop"></div>
    </section>
  );
};

export default Hero;